import { useEffect, useState } from "react";
import { SearchBasicSelectUI } from "../../ui/SearchBasicSelectUI";
import { get_centroscostos } from "../../../actions/empresa";

export const CentroCostoSelect = ({ ...restProps }) => {
  const [options, setOptions] = useState([]);
  const OnLoad = async () => {
    const datos = await get_centroscostos();

    const data = datos.map((row) => ({
      value: row.id,
      label: row.codigo + " - " + row.nombre,
    }));
    setOptions(data);
  };
  useEffect(() => {
    OnLoad();
  }, []);

  return <SearchBasicSelectUI data={options} {...restProps} />;
};
